import { bibLogo, bopLogo, iciLogo, progressiveLabLogo } from "../../assets";

export const GROUP_LIST = [
	{
		name: "Brookshire Brothers, Inc",
		number: 220,
		logo: bibLogo
	},
	{
		name: "Intercity Investments, Inc",
		number: 188,
		logo: iciLogo
	},
	{
		name: "Bank of the Panhandle",
		number: 225,
		logo: bopLogo
	},
	{
		name: "Progressive Lab",
		number: 300,
		logo: progressiveLabLogo
	}
];

export const GROUP_LIST_OBJECT = new Map<number, any>([
	[
		220,
		{
			name: "Brookshire Brothers, Inc",
			number: 220,
			logo: bibLogo
		}
	],
	[
		188,
		{
			name: "Intercity Investments, Inc",
			number: 188,
			logo: iciLogo
		}
	],
	[
		225,
		{
			name: "Bank of the Panhandle",
			number: 225,
			logo: bopLogo
		}
	],
	[
		300,
		{
			name: "Progressive Lab",
			number: 300,
			logo: progressiveLabLogo
		}
	]
]);
